import Header4 from "../../Header/Header4";
import {connect} from "react-redux";
import React, {Component} from "react";
import './index.css'
import {Button, Typography} from "antd";

const images = require.context('./images', true)
const {Title, Paragraph, Text, Link} = Typography;
const tableLines = [
    {
        name: '陆表场景制备平台',
        image: './陆表场景制备平台.jpg',
        compose: '包括特制容器和粗糙度制备装置',
        use: '提升实验室对于土壤含水量、土壤粗糙度、相关长度等参数的精准制备能力'
    },
    {
        name: '结构性介电测量平台',
        image: './结构性介电测量平台.jpg',
        compose: '包括矢量网络分析仪、电子校准件和探头等配套部件',
        use: '为深入理解电磁波与目标组件交互作用提供基础数据'
    },
    {
        name: '陆表场景监测装置',
        image: './陆表场景监测装置.jpg',
        compose: '-',
        use: '提升实验室对于土壤粗糙度、相关长度参数的精准测量能力'
    },
    {
        name: '水体场景监测装置',
        image: './水体场景监测装置1.jpg',
        compose: '包括风速仪、流速计和波潮仪',
        use: '提升实验室对于动态水体波高、波速等参数的监测能力'
    },
    {
        name: '植被场景监测装置',
        image: './植被场景监测装置1.jpg',
        compose: '包括多功能气象站一套、植被三维建模系统一套、软件处理系统一套、植物荧光仪一套、支架等其他配套部件一套',
        use: '提升实验室对于植被场景的点云采集和植被结构属性参数的监测能力'
    },
    {
        name: '定标套件',
        image: './定标套件.png',
        compose: '两面角反射器45度2套、两面角反射器90度2套、两面角反射器45度2套、两面角反射器90度2套、金属圆盘2套、金属圆盘2套、三面角反射器4套、三面角反射器8套、二面角反射器底座8套',
        use: '提升实验室微波测量系统极化定标能力'
    },
    {
        name: '全散射空间射频接收系统',
        image: './全散射空间射频接收系统.jpg',
        compose: '吸波材料、宽带天线、天线支架',
        use: '提升实验室多站模式微波特性测量与仿真能力'
    },
    {
        name: '多频极化信息接收与处理系统',
        image: './多频极化信息接收与处理系统.png',
        compose: '射频电缆、低噪放、控制计算机与控制软件、微波电路切换开关',
        use: '提升实验室多站模式微波特性测量与仿真能力'
    },
    {
        name: '水体场景制备装置',
        image: './水体场景制备装置.png',
        compose: '波浪发生器、大功率造风器、电高精度水流发生器',
        use: '提升实验室复杂水体场景的制备能力，为水体场景微波特性测量与仿真提供基础实验对象'
    },
    {
        name: '星地运动关系动力伺服平台',
        image: './星地运动关系动力伺服平台.png',
        compose: '星地运动轨道34套、星地运动系统运动平台1套、星地运动系统天线支撑架1套、供电电缆1套',
        use: '提升实验室星地运动关系模拟能力'
    },
]

class WBJZIntroduction extends Component {
    state = {
        // introductionImages: require.context('./images', true)
    }

    componentDidMount() {
    }

    render() {
        // const {introductionImages} = this.state;
        return <div>
            <Header4/>
            <div className="wbjz-background">
                <div className="typography-container">
                    <Typography>
                        <Title level={3} className="title-mid">微波基准实验室介绍</Title>
                        <Paragraph> 坐落于浙江省德清县地理信息小镇的微波目标特性测量实验室（LAMP）依托“微波特性测量与仿真成像科学实验平台”的科学技术优势而组建，该平台是一套国内首创、性能先进、功能高度集成的大型微波遥感基础实验科学装置，能为微波遥感原创性基础研究提供实验条件；通过积累基础科学数据，开拓新型微波遥感应用领域，为催生新概念微波遥感器和新型微波类卫星提供地面实验与验证手段。</Paragraph>
                        <Paragraph>
                            <div className="wbmb1-image-container">
                                <img className="wbmb1-image" src={images('./微波目标特性测量实验室1.jpg')}
                                     alt="图片正在加载中"/>
                                <div className="wbmb2-image-container">
                                    <img className="wbmb2-image"
                                         src={images('./微波目标特性测量实验室2.jpg')} alt=""/>
                                    <img className="wbmb2-image"
                                         src={images('./微波目标特性测量实验室3.jpg')} alt=""/>
                                </div>
                                <Text>微波目标特性测量实验室</Text>
                            </div>
                        </Paragraph>
                        <Paragraph>“微波测量仿真分系统”在原有LAMP平台的基础上，通过采购和定制包括结构性介电特性测量平台、陆表场景监测装置、全散射空间射频接收系统等在内的专用设备、FEKO软件以及微波测量仿真分系统专用软件建成自然目标/场景和几何精度、辐射精度验证场景等高精度目标/场景制备、监测及仿真能力，能够配合并提升现有LAMP平台的星载SAR卫星产品典型应用场景的定量化制备和自动化观测能力，典型目标场景的多方位向微波极化散射特性测量能力，星载SAR卫星产品生成过程中的算法模型验证能力。</Paragraph>
                        <Title level={4}>1、微波测量仿真分系统专用设备</Title>
                        <Paragraph>在LAMP实验室原有设备的基础上，通过新增结构性介电特性测量平台、陆表场景制备平台、水体场景制备平台、陆表场景制备平台、陆表场景监测装置、水体场景监测装置、植被场景监测装置、定标套件、全散射空间射频接收系统、多频极化信息接收与处理系统、星地运动关系动力伺服平台提升实验室对于陆表场景、土壤场景和水体场景的制备、测量和成像能力。</Paragraph>
                        <Paragraph>
                            <div className="table-container">
                                <Text style={{textAlign:'center'}}>微波测量仿真分系统专用设备信息表</Text>
                                <table className="table-style">
                                    <thead>
                                    <tr>
                                        <th className="name-th">设备名称</th>
                                        <th className="image-th">设备照片</th>
                                        <th className="compose-th">设备组成</th>
                                        <th className="use-th">设备用途</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {tableLines.map((line, i) => (
                                        <tr key={i}>
                                            <th className="name-th">{line.name}</th>
                                            <th className="image-th"><img src={images(line.image)} alt=""/></th>
                                            <th className="compose-th">{line.compose}</th>
                                            <th className="use-th">{line.use}</th>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </Paragraph>
                        <Title level={4}>2、FEKO软件</Title>
                        <Paragraph>FEKO是一款全球领先的基于计算电磁学的电磁仿真软件，广泛用于航空航天、国防、汽车、通信、消费类电子产品、能源和医疗保健行业。该套件包括了一组准确、可靠且功能强大的求解器，这些求解器可混合使用，更加轻松、高效地解决一系列电磁计算仿真问题。软件模拟仿真的地物目标微波散射场是雷达遥感正演反演模型及仿真模拟理论的基础观测量，获取不同地物目标在不同雷达观测模式下的双站微波散射场，对于微波卫星产品真实性检验、目标与电磁波交互作用机理分析及认知、雷达信号解译、建立地表参数反演模型等卫星应用技术环节有着重要意义。为雷达遥感正演反演、遥感数据的大气校正，遥感产品的地面真实性检验，以及航空、航天新型遥感器的研制和测试等提供技术和平台支撑。</Paragraph>
                        <Paragraph>
                            <div className="wbmb1-image-container">
                                <img className="wbmb1-image" src={images('./Altair FEKO.png')}
                                     alt="图片正在加载中"/>
                                <Text>Altair FEKO</Text>
                            </div>
                        </Paragraph>
                        <Title level={4}>3、微波测量仿真分系统专用软件</Title>
                        <Paragraph>微波测量仿真分系统专用软件面向基准与综合实验室中微波测量仿真分系统的应用需求，兼容分系统中各类设备生成的数据，实现包括“十三五”7颗微波卫星在内的多种观测模式的散射特性测量与图像仿真，支持形成微波测量与微波仿真两种能力。微波测量仿真分系统专用软件支持13类目标/场景的三维模型构建、后向散射系数仿真计算、属性参数管理以及条带模式、扫描模式、圆迹SAR模式和ISAR模式仿真成像。</Paragraph>
                        <Paragraph>
                            <div className="wbmb1-image-container">
                                <img className="wbmb1-image" src={images('./微波测量仿真分系统专用软件.png')}
                                     alt="图片正在加载中"/>
                                <Text>微波测量仿真分系统专用软件</Text>
                            </div>
                        </Paragraph>

                    </Typography>
                </div>
            </div>
        </div>;
    }
}

const mapState = (state) => ({
    loginObj: state.userReducer.get("loginObj").toJS(), user: state.userReducer.get("user").toJS(),
});
const mapDispatch = (dispatch) => ({});

export default connect(mapState, mapDispatch)(WBJZIntroduction);